<template>
	<div style="width: 100%; height: 100%" class="g-relative over-hide r-20">
		<!-- 图片展示 -->
		<img v-if="image" :src="image.url" alt="" @click="onPreview" />
		<!-- 点击上传 -->
		<flex-box
			v-else
			direction="column"
			align="center"
			justify="center"
			style="height: 100%; background: rgb(64, 128, 255, 0.09)"
			@click.native="showCamera = true"
		>
			<flex-box
				align="center"
				justify="center"
				class="r-full c-white over-hide"
				style="width: 80rem; height: 80rem; background: #4080ff"
			>
				<div class="width: 32rem;height: 32rem;">
					<img src="@/assets/0903/upload.png" alt="" />
				</div>
			</flex-box>
			<span class="font_small mt-1" style="color: #4080ff"
				>上传{{ cardTypeInfo.partText }}</span
			>
		</flex-box>
		<!-- 提示蒙版 -->
		<flex-box
			class="mask font_small"
			align="center"
			justify="center"
			v-if="['uploading', 'failed'].includes(image?.status)"
		>
			<span class="c-white">{{ image.message }}</span>
		</flex-box>
		<van-icon
			name="clear"
			size="40rem"
			color="red"
			class="remove"
			v-if="image && image.status != 'uploading'"
			@click="removeFile"
		/>
	</div>
	<Camera
		:card-type="cardType"
		@take-photo="onTakePhoto"
		@close="showCamera = false"
		:name="cardTypeInfo.title"
		:sample-image="cardTypeInfo.sampleImage"
		v-if="showCamera"
	>
		<template #mask>
			<template v-if="cardTypeInfo.type == 'car'">
				<div
					class="font_medium camera-mask p-3"
					v-if="cardTypeInfo.part == 'top'"
				>
					<div class="text-center">中华人民共和国机动车行驶证</div>
					<div class="font_small" style="line-height: 1.8">
						<div>
							<span>号码号牌</span>
							<span style="padding-left: 200rem">车辆类型</span>
						</div>
						<div>
							<span>所有人</span>
						</div>
						<div>
							<span>住址</span>
						</div>
						<div>
							<span>使用性质</span>
							<span style="padding-left: 140rem">品牌型号</span>
						</div>
					</div>
					<div style="height: 120rem" class="font_small">
						<div
							style="border: 1px solid #fff; width: 120rem; height: 100%"
							class="mr-2 float-left"
						></div>
						<grid-box
							rows="1fr 1fr 1fr"
							align="center"
							class="over-hide"
							style="height: 120rem; line-height: 1.2"
						>
							<span>车辆识别代号</span>
							<span>发动机号码</span>
							<span>注册时间</span>
						</grid-box>
					</div>
				</div>
				<div class="font_medium camera-mask p-3" v-else>
					<div class="text-center">中华人民共和国机动车行驶证</div>
					<div class="font_small">
						<span>号码号牌</span>
					</div>
					<div
						style="
							border: 1px solid #fff;
							width: 314rem;
							height: 48rem;
							justify-self: end;
						"
					></div>
				</div>
			</template>
		</template>
	</Camera>
</template>

<script>
import { defineComponent } from 'vue'
import Camera from './camera'
import { showImagePreview } from 'vant'
const sampleTop = require('./assets/sample-top.png')
const sampleRever = require('./assets/sample-rever.png')
export default defineComponent({
	props: {
		cardType: String,
		modelValue: Object
	},
	setup(props, { emit, slots, attrs }) {},
	data() {
		return {
			image: null,
			showCamera: false
		}
	},
	watch: {
		modelValue(val) {
			this.image = val
		}
	},
	computed: {
		cardTypeInfo() {
			const [type, part] = this.cardType.split('-')
			const typeText = { car: '行驶证', id: '身份证' }[type]
			const partText = { top: '正面', reverse: '反面' }[part]
			return {
				type,
				part,
				typeText,
				partText,
				title: typeText + partText,
				sampleImage: type == 'car' ? sampleTop : ''
			}
		}
	},
	created() {
		this.image = this.modelValue
	},
	methods: {
		removeFile() {
			this.image = null
			this.$emit('update:model-value', null)
		},
		// 拍摄组件拿到了图片
		onTakePhoto(file) {
			const url = URL.createObjectURL(file)
			this.image = { url, file, message: '', status: 'default' }
			this.$emit('update:model-value', this.image)
			this.$emit('after-read', this.image)
			this.showCamera = false
		},
		// 预览
		onPreview() {
			showImagePreview([this.image.url])
		}
	},
	components: { Camera }
})
</script>

<style lang="scss" scoped="scoped">
img {
	display: block;
	width: 100%;
	height: 100%;
}
.remove {
	position: absolute;
	right: 0;
	top: 0;
}
.mask {
	background: rgba(0, 0, 0, 0.5);
	position: absolute;
	bottom: 0;
	top: 0;
	right: 0;
	left: 0;
}
.camera-mask {
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	color: #fff;
	opacity: 0.5;
	display: grid;
	grid-template-rows: auto 1fr auto;
}
</style>
